"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ajaxPost = exports.ajaxGet = exports.noop = exports.baseUrl = exports.setOrg = exports.setAuthenticationHeaders = exports.AXIOS_CONFIG = exports.isProd = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios2 = _interopRequireDefault(require("axios"));

var _reduxActions = require("redux-actions");

var _httpActions = require("./http-actions");

var _constants = require("../constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var isProd = typeof window !== 'undefined' && window.location && !window.location.hostname.includes('localhost') && !window.location.hostname.includes('test');
exports.isProd = isProd;
var AXIOS_CONFIG = {
  timeout: 20000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  // send telemetry cookies
  withCredentials: true
};
exports.AXIOS_CONFIG = AXIOS_CONFIG;

var axios = _axios2["default"].create(AXIOS_CONFIG);

var setAuthenticationHeaders = function setAuthenticationHeaders(jwt) {
  axios.defaults.headers.common.Authorization = jwt;
};

exports.setAuthenticationHeaders = setAuthenticationHeaders;
var org;

var setOrg = function setOrg(o) {
  return org = o;
};

exports.setOrg = setOrg;

var baseUrl = function baseUrl() {
  switch (org) {
    case _constants.ORGS.PROVENANCE:
      return isProd ? 'https://provenance.io' : 'https://test.provenance.io';

    case _constants.ORGS.ADNALES:
      return isProd ? 'https://adnales.com' : 'https://test.adnales.com';

    default:
      return isProd ? 'https://www.figure.com' : 'https://test.figure.com';
  }
};
/**
 * Default noop function that can be overridden for progress indicators
 */


exports.baseUrl = baseUrl;

var noop = function noop() {};

exports.noop = noop;

function errorHandling(error) {
  if (error.response) {
    return error.response.data;
  } else if (error.request) {
    // TODO: handle request error
    console.error("Unexpected request error ".concat(error.request), error); // eslint-disable-line no-console
  } else {
    console.error("Something happened setting up the request ".concat(error.message), error); // eslint-disable-line no-console
  }

  return null;
}

var ajaxGet = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(action, dispatch, url) {
    var config,
        meta,
        dispatchHttpActions,
        result,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            config = _args.length > 3 && _args[3] !== undefined ? _args[3] : null;
            meta = _args.length > 4 && _args[4] !== undefined ? _args[4] : null;
            dispatchHttpActions = _args.length > 5 && _args[5] !== undefined ? _args[5] : true;
            if (dispatchHttpActions) dispatch((0, _httpActions.request)());
            dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.REQUEST))());
            _context.prev = 5;
            _context.next = 8;
            return axios.get(url, _objectSpread({}, config));

          case 8:
            result = _context.sent;
            dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.SUCCESS), null, function () {
              return _objectSpread({}, meta);
            })(result.data));
            return _context.abrupt("return", Promise.resolve(result.data));

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](5);
            dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.FAILURE))(errorHandling(_context.t0)));

          case 16:
            _context.prev = 16;
            if (dispatchHttpActions) dispatch((0, _httpActions.complete)());
            return _context.finish(16);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 13, 16, 19]]);
  }));

  return function ajaxGet(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

exports.ajaxGet = ajaxGet;

var ajaxPost = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(action, dispatch, url, data) {
    var meta,
        config,
        dispatchHttpActions,
        throwOnError,
        result,
        _args2 = arguments;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            meta = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : null;
            config = _args2.length > 5 && _args2[5] !== undefined ? _args2[5] : null;
            dispatchHttpActions = _args2.length > 6 && _args2[6] !== undefined ? _args2[6] : true;
            throwOnError = _args2.length > 7 && _args2[7] !== undefined ? _args2[7] : false;
            if (dispatchHttpActions) dispatch((0, _httpActions.request)());
            if (!meta) meta = data;
            dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.REQUEST), null, function () {
              return _objectSpread({}, meta);
            })());
            _context2.prev = 7;
            _context2.next = 10;
            return axios.post(url, data, _objectSpread({}, config));

          case 10:
            result = _context2.sent;
            dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.SUCCESS), null, function () {
              return _objectSpread({}, meta);
            })(result.data));
            return _context2.abrupt("return", Promise.resolve(result.data));

          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](7);

            if (!throwOnError) {
              _context2.next = 19;
              break;
            }

            throw new Error(_context2.t0);

          case 19:
            dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.FAILURE), null, function () {
              return _objectSpread({}, meta);
            })(errorHandling(_context2.t0)));

          case 20:
            _context2.prev = 20;
            if (dispatchHttpActions) dispatch((0, _httpActions.complete)());
            return _context2.finish(20);

          case 23:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[7, 15, 20, 23]]);
  }));

  return function ajaxPost(_x4, _x5, _x6, _x7) {
    return _ref2.apply(this, arguments);
  };
}();

exports.ajaxPost = ajaxPost;